<script>
import axios from "axios";

export default {
    methods: {
        setFiltersFromAddressbarUrl() {
            let pathName = window.location.pathname;

            // If is multilingual (WPML), strip from url.
            if (this.$store.state.curLang) {
                pathName = pathName.replace('/' + this.$store.state.curLang, '');
            }

            // Remove current page slug because we only need the url parts that can be filtered on
            pathName = pathName.replace('/' + this.$store.state.pageSlug + '/', '');

            if (this.$store.state.subsiteSlug) {
                let subsiteSlug = this.$store.state.subsiteSlug.slice(0, -1);
                pathName = pathName.replace(subsiteSlug, '');
            }
            pathName = pathName.slice(0, -1); // remove trailing slash

            if (pathName) {
                let filtersFromAddressbarArray = pathName.split('/');
                let processed = 0;

                filtersFromAddressbarArray.forEach(value => {
                    if (!value.includes('filter')) {

                        let termUrl = window.location.origin;

                        if (this.$store.state.subsiteSlug) {
                            termUrl += this.$store.state.subsiteSlug.slice(0, -1);
                        }

                        if (termUrl.includes('ddev')) {
                            termUrl += '/wp';
                        }

                        termUrl += '/wp-admin/admin-ajax.php?action=term_id_slug&slug=' + value + "&blog_id=" + this.$store.state.blogId;

                        if (!value.includes('page')) {
                            axios.get(termUrl).then(response => {
                                this.$store.commit('setFilterFromTermObject', response.data);
                                processed++;
                                if ((filtersFromAddressbarArray.length - 1) === processed) {
                                    this.allDone();
                                }
                            })
                                .catch(error => {
                                });
                        } else {
                            // set page number
                            let lastChar = value.slice(-1);
                            lastChar = parseInt(lastChar)

                            if (!isNaN(lastChar)) {
                                this.$store.state.page = lastChar;
                            }

                            processed++;
                            if ((filtersFromAddressbarArray.length - 1) === processed) {
                                this.allDone();
                            }
                        }
                    }

                });
            }

        },
        allDone() {
            this.$store.state.allFiltersSetFromUrl = true;
        }
    }
}
</script>
